module.exports = __webpack_public_path__ + "static/banner1_mobile-4a5821bd4524e8146ac37c83f20ad2dd.jpg";